module.exports = __webpack_public_path__ + "static/media/side_step.18936c84.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/quick-play-icons/side_step.png
// module id = 712
// module chunks = 0